import { FormAttributionAttributes } from '../types';

export const getIsFieldEnabled = (
  field: HTMLInputElement | HTMLSelectElement,
): boolean => {
  const propName = FormAttributionAttributes.FormEnabled;
  const fieldValue = toBoolean(field.getAttribute(propName) ?? true);

  if (!fieldValue) {
    return false;
  }

  const form = field.closest('form');

  return form ? getIsFormEnabled(form) : true;
};

export const getIsFormEnabled = (form: HTMLFormElement): boolean => {
  const propName = FormAttributionAttributes.FormEnabled;
  const isEnabled = toBoolean(form.getAttribute(propName) ?? true);

  return isEnabled;
};

export const getFormName = (
  field: HTMLInputElement | HTMLSelectElement,
): string | undefined => {
  const fieldName = field.getAttribute(FormAttributionAttributes.FormName);

  if (fieldName !== null && fieldName !== '') {
    return fieldName;
  }

  const form = field.closest('form');
  const formName = form?.name;

  if (typeof formName !== 'undefined' && formName !== '') {
    return formName;
  }

  const formDataAttrName = form?.getAttribute(FormAttributionAttributes.FormName);

  if (formDataAttrName !== null && formDataAttrName !== '') {
    return formDataAttrName;
  }

  return undefined;
};

export const getFieldName = (
  field: HTMLInputElement | HTMLSelectElement,
): string | undefined => {
  const trackingName = field.getAttribute(FormAttributionAttributes.FieldName);

  if (trackingName !== null && trackingName !== '') {
    return trackingName;
  }

  if (field.name !== '') {
    return field.name;
  }

  return undefined;
};

const toBoolean = (value: string | boolean | undefined | number) => {
  if (
    typeof value === 'undefined' ||
    value === false ||
    value === 0 ||
    value === 'false' ||
    value === '0' ||
    value === 'off'
  ) {
    return false;
  }

  return true;
};
